// extracted by mini-css-extract-plugin
export default {"section":"Risks_section__cbuNX","title":"Risks_title__zmQiZ","info":"Risks_info__+wieH","head":"Risks_head__X-ECS","body":"Risks_body__MQJVl"};